import { NEXT_PUBLIC_IMAGE_URL } from "@/common";

export const jobsearchintro = [
  {
    versionA: {
      title: 'Cơ hội đúng gu – không cần lướt mỏi tay.',
      description:
        'Bạn đã có định hướng, giờ là lúc xem ngoài kia có gì chờ bạn.',
      image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/job_search.png`,
      show: true,
    },
    versionB: {
      title: 'Khám phá cơ hội phù hợp',
      description:
        'Bạn đã có định hướng, giờ là lúc xem ngoài kia có gì chờ bạn.',
      image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/job_search.png`,
      show: true,
    },
  },
];
